import React from "react"

export const GalleryIcon = ({ size = 1, color = "#034055" }) => {
  return (
    <svg
      width={size * 80}
      height={size * 80}
      viewBox="0 0 80 80"
      className="gallery-icon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle fillOpacity=".8" fill="#FFFFFF" cx="40" cy="40" r="40" />
      <g id="img-icon">
        <path
          stroke={color}
          strokeWidth="2.5"
          fill="none"
          d="M31.4,30.6h21.5v16.2H31.4V30.6z"
        />
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.5,43.7l6.2-7.8c0.1-0.1,0.3-0.2,0.5-0.1c0,0,0,0,0.1,0.1l6.2,7.4l3-3.1c0.1-0.1,0.3-0.1,0.5,0l3.2,2.9v4.1
		H32.5V43.7L32.5,43.7z"
        />
        <ellipse
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          cx="47.4"
          cy="35.3"
          rx="2.2"
          ry="2.3"
        />
      </g>
      <path
        fill="none"
        id="img-base"
        stroke={color}
        strokeWidth="2.667"
        d="M26.7,35.1v16.4h22.7"
      />
    </svg>
  )
}
